export default __webpack_public_path__ + "2ac9caee2e1f6d38bad08a5faa597133.woff";